<template>
  <!-- ------------------ tab row - tabs ------------------ -->
  <v-tabs v-model="tabs_ActiveTab" height="28px" align-with-title slider-color="white" color="transparent" show-arrows next-icon="arrow_forward_ios" prev-icon="arrow_back_ios">
    <v-tab exact v-for="(tab, index) in tabs_allTabs" :mytabindex="index" @contextmenu="showRightClickMenu" :to="tab.tab_fullPath" :key="tab.tab_id" ripple class="text-capitalize">
      {{ tab.tab_title }}
      <v-btn @click.stop.prevent="closeTag(index)" icon class="tab-btn" title="Close tab">&times;</v-btn>
    </v-tab>
    <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
      <v-list>
        <v-list-tile v-for="(item, index) in contextMenuItems" :key="index" @click="item.action(rightClickedTab)">
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-tabs>
</template>

<script>
export default {
  data() {
    return {
      rightClickedTab: {},
      showMenu: false,
      x: 0,
      y: 0,
      contextMenuItems: [
        { title: 'Refresh', action: rightClickedTab => this.refreshSelectedTag(rightClickedTab) },
        { title: 'Close', action: rightClickedTab => this.closeTag(rightClickedTab) },
        { title: 'Close Others', action: () => this.closeOthersTags() },
        { title: 'Close All', action: () => this.closeAllTags() }
      ]
    }
  },
  computed: {
    tabs_ActiveTab: {
      set(activeTab) {
        this.$store.dispatch('activeTab', activeTab)
      },
      get() {
        return this.$store.getters.activeTab
      }
    },
    tabs_allTabs() {
      return this.$store.state.tabsRow.allTabs
    }
  },
  watch: {
    $route() {
      this.addTab()
      this.moveToRightClickedTab()
    }
  },
  mounted() {
    this.addTab()
  },
  methods: {
    addTab() {
      if (this.$route.meta.addToTabs) {
        this.$store.dispatch('addTab', this.$route)
      }
    },
    getTab: function (index) {
      return this.$store.state.tabsRow.allTabs[index]
    },
    isThisTabActive(fullPath) {
      return fullPath === this.$route.fullPath
    },
    moveToRightClickedTab() {
      if (this.rightClickedTab.fullPath) {
        this.tabs_ActiveTab = this.rightClickedTab.fullPath
      }
    },
    refreshSelectedTag(tabObj) {
      this.$store.dispatch('deleteTab', tabObj).then(() => {
        const fullPath = tabObj.tab_fullPath
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    closeTag(tabObj) {
      if (typeof tabObj === 'number') {
        tabObj = this.tabs_allTabs[tabObj]
      }
      if (typeof tabObj === 'object') {
        this.$store.dispatch('deleteTab', tabObj)
          .then(views => {
            if (this.isThisTabActive(tabObj.tab_fullPath)) {
              const latestView = views.slice(-1)[0]
              if (latestView) {
                this.$router.push(latestView.tab_fullPath)
              } else {
                this.$router.push('/')
              }
            }
          })
      }
    },
    closeOthersTags() {
      this.$router.push(this.rightClickedTab)
      this.$store.dispatch('delOthersViews', this.rightClickedTab).then(() => {
        this.moveToRightClickedTab()
      })
    },
    closeAllTags() {
      this.$store.dispatch('delAllViews')
      this.$router.push('/')
      this.tabs_ActiveTab = '/'
    },
    showRightClickMenu(e) {
      // set this.rightClickedTab
      const selectedTabIndex = e.srcElement.parentElement.attributes.mytabindex.nodeValue
      this.rightClickedTab = this.getTab(selectedTabIndex)
      // show menu
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    }
  }
}
</script>

<style scoped>
.tab-btn {
  width: 14px;
  height: 14px;
  margin: 0px;
  top: -1px;
}
.tab-close {
  font-size: 10px;
}
</style>
